export interface Product {
  name: string;
  category: string;
  image: string;
}

export const vegetableProducts: Product[] = [
  { name: 'Cucumber', category: 'vegetables', image: '/images/product-cucumber.jpg' },
  { name: 'Radish', category: 'vegetables', image: '/images/product-radish.jpg' },
  { name: 'Tomato', category: 'vegetables', image: '/images/product-tomato.jpg' },
  { name: 'Lady Finger', category: 'vegetables', image: '/images/product-ladyfinger.jpg' },
  { name: 'Bottle Gourd', category: 'vegetables', image: '/images/product-bottle-gourd.jpg' },
  { name: 'Cauliflower', category: 'vegetables', image: '/images/product-cauliflower.jpg' },
  { name: 'Cabbage', category: 'vegetables', image: '/images/product-cabbage.jpg' },
  { name: 'Brinjal', category: 'vegetables', image: '/images/product-brinjal.jpg' },
  { name: 'Beetroot', category: 'vegetables', image: '/images/product-beetroot.jpg' },
  { name: 'Green Chilly', category: 'vegetables', image: '/images/product-green-chilly.jpg' },
  { name: 'Taro Root', category: 'vegetables', image: '/images/product-taro-root.jpg' },
  { name: 'Spring Onion', category: 'vegetables', image: '/images/product-spring-onion.jpg' },
  { name: 'Potato', category: 'vegetables', image: '/images/product-potato.jpg' },
  { name: 'Onion', category: 'vegetables', image: '/images/product-onion.jpg' },
  { name: 'Garlic', category: 'vegetables', image: '/images/product-garlic.jpg' },
  { name: 'Carrot', category: 'vegetables', image: '/images/product-carrot.jpg' },
  { name: 'Peas', category: 'vegetables', image: '/images/product-peas.jpg' },
  { name: 'Ginger', category: 'vegetables', image: '/images/product-ginger.jpg' },
  { name: 'Bitter Gourd', category: 'vegetables', image: '/images/product-bitter-gourd.jpg' },
  { name: 'Ridge Gourd', category: 'vegetables', image: '/images/product-ridge-gourd.jpg' },
  { name: 'Capsicum', category: 'vegetables', image: '/images/product-capsicum.jpg' },
  { name: 'Pumpkin', category: 'vegetables', image: '/images/product-pumpkin.jpg' },
  { name: 'Mushroom', category: 'vegetables', image: '/images/product-mushroom.jpg' },
];

export const fruitProducts: Product[] = [
  { name: 'Banana', category: 'fruits', image: '/images/product-banana.jpg' },
  { name: 'Papaya', category: 'fruits', image: '/images/product-papaya.jpg' },
  { name: 'Apple', category: 'fruits', image: '/images/product-apple.jpg' },
  { name: 'Mango', category: 'fruits', image: '/images/product-mango.jpg' },
  { name: 'Guava', category: 'fruits', image: '/images/product-guava.jpg' },
  { name: 'Orange', category: 'fruits', image: '/images/product-orange.jpg' },
  { name: 'Strawberry', category: 'fruits', image: '/images/product-strawberry.jpg' },
  { name: 'Pear', category: 'fruits', image: '/images/product-pear.jpg' },
  { name: 'Peach', category: 'fruits', image: '/images/product-peach.jpg' },
  { name: 'Young Coconut', category: 'fruits', image: '/images/product-young-coconut.jpg' },
  { name: 'Lemon', category: 'fruits', image: '/images/product-lemon.jpg' },
  { name: 'Lychee', category: 'fruits', image: '/images/product-lychee.jpg' },
  { name: 'Dates', category: 'fruits', image: '/images/product-dates.jpg' },
  { name: 'Sweet Lime', category: 'fruits', image: '/images/product-sweet-lime.jpg' },
  { name: 'Watermelon', category: 'fruits', image: '/images/product-watermelon.jpg' },
  { name: 'Musk Melon', category: 'fruits', image: '/images/product-musk-melon.jpg' },
];

export const allProducts: Product[] = [...vegetableProducts, ...fruitProducts];
